import { GENDER, type Gender } from 'constants/_types/Gender';

export const normalizeGender = (reportGender: 'male' | 'female'): Gender => {
  if (reportGender === 'male') return GENDER.m;
  if (reportGender === 'female') return GENDER.k;
  return GENDER.m;
};
